import { Button, Col, Row, Table, Tag } from 'antd';
import { useState } from 'react';
import i18n from "../../../../../utils/i18n";
import "./country-table.scss";
import { UsFlag, CaFlag } from '../../../../atoms/icon'

interface Props {
    countryCode: string;
    data: any[]
}

const CountryTable = ({ countryCode, data }: Props) => {

    const columns = [
        {
            title: "",
            dataIndex: 'title',
            key: 'title',
            width: 300,
            align: 'left' as const,
            render: (text: string) => {
                return <div className='column-with-line' >
                    {text && <div className='line' ></div>}
                    <div>
                        {text}
                    </div>
                </div>
            },
            fixed: 'left' as const,
        },
        {
            width: 100,
            title: i18n.t("FundsTransferPricing.date"),
            dataIndex: 'date',
            key: 'date',
            render: (text: string)=> <span className='percent' >{text}</span>
        },
        {
            title: '0/n',
            dataIndex: '0/n',
            key: '0/n',
            render: (text: string, record: any, index: number) => {
                const isLastRow = index === data.length - 1;
                return (
                    isLastRow ? <Tag className='percent-tag'>{text}</Tag> : <span className='percent' >{text}</span>

                );
            }
        },
        {
            title: '1m',
            dataIndex: '1m',
            key: '1m',
            render: (text: string, record: any, index: number) => {
                const isLastRow = index === data.length - 1;
                return (
                    isLastRow ? <Tag className='percent-tag'>{text}</Tag> : <span className='percent' >{text}</span>

                );
            }
        },
        {
            title: '3m',
            dataIndex: '3m',
            key: '3m',
            render: (text: string, record: any, index: number) => {
                const isLastRow = index === data.length - 1;
                return (
                    isLastRow ? <Tag className='percent-tag'>{text}</Tag> : <span className='percent' >{text}</span>

                );
            }
        },
        {
            title: '6m',
            dataIndex: '6m',
            key: '6m',
            render: (text: string, record: any, index: number) => {
                const isLastRow = index === data.length - 1;
                return (
                    isLastRow ? <Tag className='percent-tag'>{text}</Tag> : <span className='percent' >{text}</span>

                );
            }
        },
        {
            title: '1',
            dataIndex: 'one',
            key: 'one',
            render: (text: string, record: any, index: number) => {
                const isLastRow = index === data.length - 1;
                return (
                    isLastRow ? <Tag className='percent-tag'>{text}</Tag> : <span className='percent' >{text}</span>

                );
            }
        },
        {
            title: '2',
            dataIndex: 'two',
            key: 'two',
            render: (text: string, record: any, index: number) => {
                const isLastRow = index === data.length - 1;
                return (
                    isLastRow ? <Tag className='percent-tag'>{text}</Tag> : <span className='percent' >{text}</span>

                );
            }
        },
        {
            title: '3',
            dataIndex: 'three',
            key: 'three',
            render: (text: string, record: any, index: number) => {
                const isLastRow = index === data.length - 1;
                return (
                    isLastRow ? <Tag className='percent-tag'>{text}</Tag> : <span className='percent' >{text}</span>

                );
            }
        },
        {
            title: '4',
            dataIndex: 'four',
            key: 'four',
            render: (text: string, record: any, index: number) => {
                const isLastRow = index === data.length - 1;
                return (
                    isLastRow ? <Tag className='percent-tag'>{text}</Tag> : <span className='percent' >{text}</span>

                );
            }
        },
        {
            title: '5',
            dataIndex: 'five',
            key: 'five',
            render: (text: string, record: any, index: number) => {
                const isLastRow = index === data.length - 1;
                return (
                    isLastRow ? <Tag className='percent-tag'>{text}</Tag> : <span className='percent' >{text}</span>

                );
            }
        },
        {
            title: '7',
            dataIndex: 'seven',
            key: 'seven',
            render: (text: string, record: any, index: number) => {
                const isLastRow = index === data.length - 1;
                return (
                    isLastRow ? <Tag className='percent-tag'>{text}</Tag> : <span className='percent' >{text}</span>

                );
            }
        },
        {
            title: '10',
            dataIndex: 'ten',
            key: 'ten',
            render: (text: string, record: any, index: number) => {
                const isLastRow = index === data.length - 1;
                return (
                    isLastRow ? <Tag className='percent-tag'>{text}</Tag> : <span className='percent' >{text}</span>

                );
            }
        },
    ];

    const renderFlag = () => {
        switch (countryCode) {
            case "can":
                return <span className='flag-item'> <CaFlag /> <b>CAD</b> </span>
            case "usd":
                return <span className='flag-item'> <UsFlag /> <b>USD</b> </span>
            default:
                return "";
        }
    }

    return (
        <div className='country-table-wrapper'>
            <Button className='yellow-contained'>
                {renderFlag()}
            </Button>
            <Row>
                <Col span={24}>
                    <Table
                        scroll={{ x: 1360 }}
                        loading={false}
                        dataSource={data}
                        pagination={false}
                        columns={columns} rowKey="id" />
                </Col>
            </Row>
        </div>
    )
}

export default CountryTable